// フォームの処理などの共通関数および共通props
export default {
  data: () => ({
    cpno: window.Laravel.cpno,
    csrfToken: window.Laravel.csrfToken
  }),
  methods: {
    // バリデーション処理
    validateBeforeSubmit() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(result => {
          if (!result) {
            // エラーがある要素までスクロール
            // console.error(this.errors)
            if (this.errors.items[0]) {
              let target = `[data-vv-id="${this.errors.items[0].id}"]`
              let position = $(target).offset().top
              // 項目が隠れている場合は親のdivでtop取得
              if ($(target).css('display') === 'none' || $(target).attr('type') === 'hidden') {
                position = $(target)
                  .parent('div')
                  .offset().top
              }
              $('html, body').animate({ scrollTop: position - 88 }, 250)
            }
            return reject()
          }
          return resolve()
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/EntryForm/mixins/formControl.js